module.exports = __webpack_public_path__ + "img/wbanner_31.1ebf84c0.png";